import LocalizedStrings from 'localized-strings';

interface CreateNewTransferCheckDetailsLocalizedType {
  amount: string;
  checkDetails: string;
  confirm: string;
  email: string;
  emailConfirmationDetail: string;
  emailIsRequiredError: string;
  feeDetails: string;
  feeDetailsQuotaReached: string;
  fees: string;
  firstOccurrence: string;
  frequency: string;
  instantTransfer: string;
  label: string;
  lastOccurrence: string;
  noneLabel: string;
  notifyBeneficiary: string;
  schedule: string;
  scheduledFeeDetails: string;
  scheduledFees: string;
  shouldNotifyRecipient: string;
  standardTransfer: string;
  standardTransferTooltip: string;
  transferRecap: string;
  transferType: string;
  scheduledTransfer: string;
}

export default new LocalizedStrings<CreateNewTransferCheckDetailsLocalizedType>(
  {
    en: {
      amount: 'Amount',
      checkDetails: 'Verify information',
      confirm: 'Confirm transfer',
      email: 'E-mail',
      emailConfirmationDetail:
        'Your beneficiary will be informed once the transfer is confirmed.',
      emailIsRequiredError: `In order to send a confirmation, do not forget to fill an email right here`,
      feeDetails:
        'You still have {nbFreeBankTransfersLeft} SEPA bank transfers included in your offer this month. Any additional transfers will be charged {formattedFixedFees} excl. VAT.',
      feeDetailsQuotaReached:
        'You have reached your monthly quota of SEPA bank transfers included in your offer. Any additional transfer will be charged {formattedFixedFees} excl. VAT.',
      fees: 'Fees',
      firstOccurrence: 'First occurrence',
      frequency: 'Frequency',
      instantTransfer: 'Instant',
      label: 'Label',
      lastOccurrence: 'Last occurrence',
      noneLabel: 'None',
      notifyBeneficiary: 'Inform your beneficiary',
      schedule: 'Schedule',
      scheduledFeeDetails:
        'If your monthly transaction limit is exceeded on the next due date, the scheduled transfer will be charged {formattedFixedFees} excl. VAT.',
      scheduledFees: 'According to limit',
      scheduledTransfer: 'Scheduled',
      shouldNotifyRecipient: 'Send confirmation by mail',
      standardTransfer: 'Standard',
      standardTransferTooltip:
        'Your transfer will be sent within 2 to 3 working days after issue.',
      transferRecap: 'Transfer summary',
      transferType: 'Type of transfer',
    },
    fr: {
      amount: 'Montant',
      checkDetails: 'Vérifiez les informations',
      confirm: 'Confirmer l’envoi',
      email: 'E-mail',
      emailConfirmationDetail:
        'Votre bénéficiaire sera informé une fois le virement validé.',
      emailIsRequiredError:
        "Afin d'envoyer une confirmation, n'oubliez pas de renseigner un e-mail juste ici.",
      feeDetails:
        'Vous disposez encore de {nbFreeBankTransfersLeft} mouvements bancaires SEPA inclus dans votre offre ce mois-ci. Tout virement additionnel est facturé {formattedFixedFees} HT.',
      feeDetailsQuotaReached:
        'Vous avez atteint votre limite mensuelle de mouvements bancaires SEPA gratuits inclus dans votre offre. Tout virement additionnel est facturé {formattedFixedFees} HT.',
      fees: 'Frais',
      firstOccurrence: 'Première échéance',
      frequency: 'Fréquence',
      instantTransfer: 'Instantané',
      label: 'Libellé',
      lastOccurrence: 'Dernière échéance',
      noneLabel: 'Aucun',
      notifyBeneficiary: 'Prévenir votre bénéficiaire',
      schedule: 'Planification',
      scheduledFeeDetails:
        'Si votre plafond mensuel de mouvements bancaires SEPA inclus est dépassé à la prochaine échéance, le virement programmé sera facturé {formattedFixedFees} HT.',
      scheduledFees: 'Selon plafond',
      scheduledTransfer: 'Programmé',
      shouldNotifyRecipient: 'Envoyer une confirmation par e-mail',
      standardTransfer: 'Standard',
      standardTransferTooltip:
        'Votre virement sera envoyé sous 2 à 3 jours ouvrés après l’émission.',
      transferRecap: 'Récapitulatif du virement',
      transferType: 'Type de virement',
    },
  } as const,
);
